import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button, Card, CardDescription, CardHeader, CardTitle } from '@monigo/ui';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="container max-w-md py-12">
      <Card>
        <CardHeader>
          <CardTitle>{t('errors.notFoundTitle')}</CardTitle>
          <CardDescription>{t('errors.notFoundBody')}</CardDescription>
        </CardHeader>
        <Link to="/">
          <Button>{t('errors.goHome')}</Button>
        </Link>
      </Card>
    </div>
  );
}
